import React, { useMemo, useState } from "react";

interface ExperimentDebuggerProps {
  experiments: Record<string, string[]>;
  activeVariants: Record<string, string>;
  onChange: (name: string, variant: string) => void;
}

export function ExperimentDebugger({
  experiments,
  activeVariants,
  onChange,
}: ExperimentDebuggerProps): React.ReactElement {
  const [open, setOpen] = useState(false);

  const experimentsToRender = useMemo(
    () =>
      Object.entries(experiments).filter(([name]) => name in activeVariants),
    [activeVariants, experiments]
  );

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: "50%",
        zIndex: 99999,
        background: "#fff",
        transform: open ? "translateX(-50%)" : "translate(-50%, -100%)",
        padding: "5px 10px 10px",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        transition: "transform 0.5s ease-in-out",
      }}
    >
      {experimentsToRender.length ? (
        experimentsToRender.map(([name, variants]) => (
          <div key={name}>
            <p style={{ fontWeight: "bold" }}>{name}</p>
            <select
              value={activeVariants[name]}
              onChange={e => {
                onChange(name, e.target.value);
              }}
            >
              {variants.map(variant => (
                <option key={variant}>{variant}</option>
              ))}
            </select>
          </div>
        ))
      ) : (
        <p style={{ fontWeight: "bold" }}>No experiments currently active</p>
      )}
      <button
        style={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translate(-50%, 100%)",
          background: "#fff",
          border: "none",
          padding: "5px",
          outline: "none",
          borderBottomLeftRadius: "4px",
          borderBottomRightRadius: "4px",
        }}
        onClick={() => setOpen(!open)}
      >
        {open ? "Close" : "Open"}
      </button>
    </div>
  );
}
